<template>
  <div style="background-color:white;">
    <v-btn block @click="handleGetConfig" color="blue" v-if="!dialog">
      Cargar actividades en columnas
    </v-btn>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card
        class="activity-list"
      >
        <v-toolbar
          dark
          color="primary"
          style="width:100%;"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Listado</v-toolbar-title>
          <v-spacer></v-spacer>
          <!--v-toolbar-items>
            <v-btn
              dark
              text
              @click="dialog = false"
            >
              Save
            </v-btn>
          </v-toolbar-items-->
        </v-toolbar>
        <div style="background-color: white;">
          <table border="0" v-if="!loading" style="font-weight: 700;text-align:center;margin-top: 64px;background-color:white;" cellspacing="0" cellspading="0">
            <tr>
              <td 
                v-for="p of plans"
                :key="p.id"
                :style="{ 'background-color': p.bgcolor, color: p.color }"
                :colspan="p.colspan"
                style="padding: 10px 10px 20px 10px;font-size: 1.5rem;"
              >
                {{p.id.toUpperCase()}}
              </td>
            </tr>
            <tr>
              <td 
                v-for="(c, index) of categories"
                :key="c.id"
                :style="{ 'background-color': c.bgcolor.concat(index%2=== 0 ? '' : 'CC'), color: c.color,  }"
                :colspan="c.colspan"
                style="padding: 0 10px;"
              >
                {{c.name}}
              </td>
            </tr>
            <!--tr>
              <td 
                v-for="(w, index) of weekdays"
                :key="`weekday${index}`"
                :style="{ 'background-color': w.bgcolor.concat(index%2=== 0 ? '' : 'CC'), color: w.color,  }"
                :colspan="w.colspan"
                style="padding: 0 10px;"
              >
                {{w.name}}
              </td>
            </tr-->
            <tr>
              <td 
                v-for="(s, index) of subcategories"
                :key="`${index}-${s.id}`"
                :style="{ 'background-color': s.bgcolor, color: s.color }"
                style="padding: 0 10px;min-width: 150px;border-top: 2px solid black;"
              >
                {{s.name}}
              </td>
            </tr>
            <tr 
              v-for="r in numRows"
              :key="r"
            >
              <td 
                v-for="(s, index) of subcategories"
                :key="`${s.id}-${r}-${index}`"
                :style="{ 'background-color': s.id === 'standard' ? '#acacac' : '#d7d7d7', color: s.color }"
                style="padding: 5px 10px;"
              >
                {{s.events[r-1] ? s.events[r-1].Title : ''}}
              </td>
            </tr>
          </table>
        </div>
      </v-card>
    </v-dialog>
  <!--div style="padding-top: 30px;" >
    <v-btn block @click="handleGetConfig" color="blue" v-if="!loaded">
      Cargar actividades en columnas
    </v-btn>
    <div style="padding-top: 0;overflow-x: auto;">
      <table border="0" v-if="!loading" style="font-weight: 700;text-align:center;margin-bottom: 20px;" cellspacing="0" cellspading="0">
        <tr>
          <td 
            v-for="p of plans"
            :key="p.id"
            :style="{ 'background-color': p.bgcolor, color: p.color }"
            :colspan="p.colspan"
            style="padding: 10px 10px 20px 10px;font-size: 1.5rem;"
          >
            {{p.id.toUpperCase()}}
          </td>
        </tr>
        <tr>
          <td 
            v-for="(c, index) of categories"
            :key="c.id"
            :style="{ 'background-color': c.bgcolor.concat(index%2=== 0 ? '' : 'CC'), color: c.color,  }"
            :colspan="c.colspan"
            style="padding: 0 10px;"
          >
            {{c.name}}
          </td>
        </tr>
        <tr>
          <td 
            v-for="s of subcategories"
            :key="s.id"
            :style="{ 'background-color': s.bgcolor, color: s.color }"
            style="padding: 0 10px;min-width: 150px;border-top: 2px solid black;"
          >
            {{s.name}}
          </td>
        </tr>
        <tr 
          v-for="r in numRows"
          :key="r"
        >
          <td 
            v-for="s of subcategories"
            :key="`${s.id}-${r}`"
            :style="{ 'background-color': s.id === 'standard' ? '#acacac' : '#d7d7d7', color: s.color }"
            style="padding: 0 10px;min-width: 200px;"
          >
            {{s.events[r-1] ? s.events[r-1].Title : ''}}
          </td>
        </tr>
      </table>
    </div-->
  </div>
</template>
<script>
import api from '@/services/api'
export default {
  data: () => ({
    dialog: false,
    loading: false,
    loadingData: false,
    config: null,
    plans: null,
    categories: null,
    subcategories: null,
    weekdays: null,
    events: null,
    numRows: 0,
    loaded: false,
  }),
  computed: {
    typologies () {
      return [
        { id: 'standard', name: { es: "Est�ndar" } },
        { id: 'special', name: { es: "Especial" } },
      ]
    },
  },
  mounted () {
  },
  methods: {
    handleGetEvents () {
      if (!this.subcategories || this.subcategories.length === 0) return 
      this.loadingData = true
      api.getAllWithoutLimit ('dviewcontent', 'v1/private/activity-barcelo-01/excel/simple-columns')
        .then(response => {
          this.numRows = 0
          //console.log(response.filter(x => x.PlanID === 'barcy-club' && x.CategoryID === 'barcy-disco'))
          for (const item of this.subcategories) {

          //console.log(item.plan, item.category, item.id, response.filter(x => x.PlanID === item.plan && x.CategoryID === item.category && && item.id === x.Typology))
            //item.events = response.filter(x => x.PlanID === item.plan && x.CategoryID === item.category && item.id === x.Typology)
            //let events = response.filter(x => x.PlanID === item.plan && x.CategoryID === item.category && item.id === x.Typology && item.weekday === x.WeekdayID).map(e => {
            let events = response.filter(x => x.PlanID === item.plan && x.CategoryID === item.category && item.id === x.Typology).map(e => {
              //console.log(item, e)
              return {
                Title: e.Title
              }
            })
            item.events = events.filter((obj, index, self) =>
              index === self.findIndex((t) => t.Title === obj.Title)
            )
            if (item.events.length > this.numRows) this.numRows = item.events.length
          }
          this.loadingData = false
          this.loaded = true
        })
        .catch (err => {
          console.log(err)
          this.loadingData = false
        })
    },
    handleGetConfig () {
      this.dialog = true
      this.loading = true
      api.getAllWithoutLimit ('dviewcontent', 'v1/private/activity-barcelo-01/excel/config/')
        .then(response => {
          this.config = response
          this.plans = []
          this.categories = []
          this.weekdays = []
          this.subcategories = []
          for (const p of this.config) {
            if (p.category.length === 0) p.category.push({ id: null, name: '' })
            if (!p.weekday ||  p.weekday.length === 0) p.weekday = [{ id: null, name: '' }]
            this.plans.push({
              bgcolor: p.color,
              color: 'white',
              id: p.id,
              name: p.name.es,
              colspan: this.typologies.length * p.category.length //* p.weekday.length
            })    
            for (const c of p.category) {
              this.categories.push({
                bgcolor: p.color,
                color: 'white',
                plan: p.id,
                id: c.id,
                name: c.name.es,
                colspan: (this.typologies.length || 1)// * p.weekday.length
              })    
              /*
              for (const w of p.weekday) {
                this.weekdays.push({
                  bgcolor: p.color,
                  color: 'white',
                  plan: w.id,
                  id: w.id,
                  name: w.name.es,
                  colspan: (this.typologies.length || 1)
                })
                */
                for (const s of this.typologies) {
                  this.subcategories.push({
                    bgcolor: '#dae9ff',
                    color: 'black',
                    plan: p.id,
                    category: c.id,
                    //weekday: w.id,
                    id: s.id,
                    name: s.name.es,
                    events: []
                  })    
                }
              //}
            }
          }
          this.handleGetEvents()
          this.loading = false
        })
        .catch (err => {
          console.log(err)
          this.loading = false
        })
    },
  },
}
</script>
<style scoped>
.activity-list header {
  position: fixed;
  top: 0;
}
</style>
